'use client';
import type { FC } from 'react';
import { useMemo } from 'react';
import {
  useTrackSeriesNextStoryToRead,
  type StoredNextStory,
} from '~/common/hooks/use-track-series-next-story-to-read';
import { routes } from '~/utils/routes';
import { ButtonNextLink, Button } from '@app/_components/button';
import { useLocalHooks } from './use-local-hooks';
type Props = {
  firstStoryId: string;
  firstStoryIsVipOnly: boolean;
  seriesId: string;
};

export const ReadNextStoryButton: FC<Props> = ({
  seriesId,
  firstStoryId,
  firstStoryIsVipOnly,
}) => {
  const { getLastReadStoryIdAndSeriesIndex } = useTrackSeriesNextStoryToRead();
  const { showVipOnlyModal, userIsVip } = useLocalHooks();

  const nextStory: StoredNextStory | undefined = useMemo(() => {
    return getLastReadStoryIdAndSeriesIndex(seriesId);
  }, [getLastReadStoryIdAndSeriesIndex, seriesId]);

  const label = useMemo(() => {
    const idx = nextStory?.storySeriesIndex || 1;
    return idx === 1 ? '1話から読む' : `続きから読む - ${idx}話`;
  }, [nextStory?.storySeriesIndex]);

  const isVipOnlyCase = useMemo(() => {
    if (userIsVip) return false;

    return nextStory ? nextStory.isVipOnly : firstStoryIsVipOnly;
  }, [firstStoryIsVipOnly, nextStory, userIsVip]);

  return (
    <>
      {isVipOnlyCase ? (
        <Button
          marginTop="16px"
          borderRadius="8px"
          fontSize="size_16"
          fontWeight="600"
          onClick={(e) =>
            showVipOnlyModal(e, nextStory?.storyId || firstStoryId)
          }
        >
          {label}
        </Button>
      ) : (
        <ButtonNextLink
          marginTop="16px"
          borderRadius="8px"
          fontSize="size_16"
          fontWeight="600"
          href={routes.story.url(nextStory?.storyId || firstStoryId)}
        >
          {label}
        </ButtonNextLink>
      )}
    </>
  );
};
